import React from 'react';
import { F90N } from '../../../services/p9209Api';
import { dateToInput, approvalLabel } from '../helpers';

interface Tab2Props {
  formData: Partial<F90N>;
  names: Record<string, string>;
}

/** Page 2 — Approval info (all fields readonly per spec BR-E02) */
const Tab2Approval: React.FC<Tab2Props> = React.memo(({ formData, names }) => {
  return (
    <div className="tab-content-inner">
      <div className="approval-grid">
        {/* 主管層級 */}
        <div className="approval-section">
          <div className="section-title">主管核准</div>
          <div className="form-grid form-grid-2col">
            <label>核准意見</label>
            <div><span className="approval-value">{approvalLabel(formData.f90n_61)}</span></div>

            <label>主管代號</label>
            <div className="lookup-field">
              <input value={String(formData.f90n_62 || '')} disabled readOnly />
              <span className="lookup-name">{names.supervisor || ''}</span>
            </div>

            <label>核准日期</label>
            <div>
              <input type="date" value={dateToInput(formData.f90n_63 as string | null)} disabled readOnly />
            </div>

            <label>核准說明</label>
            <div>
              <textarea value={String(formData.f90n_64 || '')} disabled readOnly rows={2} style={{ width: '100%' }} />
            </div>
          </div>
        </div>

        {/* 人事主管層級 */}
        <div className="approval-section">
          <div className="section-title">人事主管確認</div>
          <div className="form-grid form-grid-2col">
            <label>核准意見</label>
            <div><span className="approval-value">{approvalLabel(formData.f90n_66)}</span></div>

            <label>人事主管代號</label>
            <div className="lookup-field">
              <input value={String(formData.f90n_67 || '')} disabled readOnly />
              <span className="lookup-name">{names.hrManager || ''}</span>
            </div>

            <label>確認日期</label>
            <div>
              <input type="date" value={dateToInput(formData.f90n_68 as string | null)} disabled readOnly />
            </div>

            <label>核准說明</label>
            <div>
              <textarea value={String(formData.f90n_69 || '')} disabled readOnly rows={2} style={{ width: '100%' }} />
            </div>
          </div>
        </div>

        {/* 副總層級 */}
        <div className="approval-section">
          <div className="section-title">副總核准</div>
          <div className="form-grid form-grid-2col">
            <label>核准意見</label>
            <div><span className="approval-value">{approvalLabel(formData.f90n_71)}</span></div>

            <label>副總代號</label>
            <div className="lookup-field">
              <input value={String(formData.f90n_72 || '')} disabled readOnly />
              <span className="lookup-name">{names.vicePresident || ''}</span>
            </div>

            <label>核准日期</label>
            <div>
              <input type="date" value={dateToInput(formData.f90n_73 as string | null)} disabled readOnly />
            </div>

            <label>核准說明</label>
            <div>
              <textarea value={String(formData.f90n_74 || '')} disabled readOnly rows={2} style={{ width: '100%' }} />
            </div>
          </div>
        </div>

        {/* 總經理層級 */}
        <div className="approval-section">
          <div className="section-title">總經理核准</div>
          <div className="form-grid form-grid-2col">
            <label>核准意見</label>
            <div><span className="approval-value">{approvalLabel(formData.f90n_76)}</span></div>

            <label>總經理代號</label>
            <div className="lookup-field">
              <input value={String(formData.f90n_77 || '')} disabled readOnly />
              <span className="lookup-name">{names.president || ''}</span>
            </div>

            <label>核准日期</label>
            <div>
              <input type="date" value={dateToInput(formData.f90n_78 as string | null)} disabled readOnly />
            </div>

            <label>核准說明</label>
            <div>
              <textarea value={String(formData.f90n_79 || '')} disabled readOnly rows={2} style={{ width: '100%' }} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
});

Tab2Approval.displayName = 'Tab2Approval';
export default Tab2Approval;
